import { render, staticRenderFns } from "./ModalDeadAir.vue?vue&type=template&id=d8c55016"
import script from "./ModalDeadAir.vue?vue&type=script&lang=js"
export * from "./ModalDeadAir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports